var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGfxNoTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 198.5 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-7{fill:#6c63ff;}.cls-1,.cls-14,.cls-6{opacity:0.1;}.cls-1,.cls-19,.cls-22,.cls-26,.cls-32,.cls-6{isolation:isolate;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:#d38884;}.cls-4{fill:#444053;}.cls-5{fill:#b07473;}.cls-8{fill:#67647e;}.cls-9{fill:#585268;}.cls-10{fill:#e1e7ef;}.cls-11{fill:url(#linear-gradient-2);}.cls-12{fill:#a27772;}.cls-13{fill:#cc818c;}.cls-15{fill:#f6f8fb;}.cls-16{fill:url(#linear-gradient-3);}.cls-17{fill:#65617d;}.cls-18{fill:#fbbebe;}.cls-19{opacity:0.05;}.cls-20{fill:#7c5c5c;}.cls-21{fill:url(#linear-gradient-4);}.cls-22{fill:#fff;opacity:0.5;}.cls-23{fill:#3f2b3b;}.cls-24{fill:none;stroke:#3f2b3b;stroke-miterlimit:10;}.cls-25{fill:#a8a8a8;}.cls-26{opacity:0.2;}.cls-27{fill:url(#linear-gradient-5);}.cls-28{fill:#3f3d56;}.cls-29{fill:#575a89;}.cls-30{fill:#3c354c;}.cls-31{fill:#ffc1c7;}.cls-32{opacity:0.1;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 115.2,
    y1: 101.93,
    x2: 115.2,
    y2: 205.07,
    gradientTransform: "matrix(1, 0, 0, -1, -31.16, 225.86)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "gray",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "gray",
    stopOpacity: 0.12
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "gray",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 148.46,
    y1: 92.95,
    x2: 148.46,
    y2: 199.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 178.57,
    y1: 85,
    x2: 178.57,
    y2: 187.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 123.74,
    y1: 76.62,
    x2: 123.74,
    y2: 100.65,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 9188.25,
    y1: 25.27,
    x2: 9188.25,
    y2: 134.78,
    gradientTransform: "translate(9239.5 164.5) rotate(180)",
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 25") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.14,70.93c3.14,12.24,9.79,22.82,20.3,27.95,21.85,10.66,71.09,5.16,107.85-1.15a86.33,86.33,0,0,0,47.86-25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M194.9,13.32H174.74A1.68,1.68,0,0,1,173,11.73a1.68,1.68,0,0,1,1.74-1.59h3.49a1.68,1.68,0,0,1-1.74-1.59A1.68,1.68,0,0,1,178.22,7h-2.49A1.68,1.68,0,0,1,174,5.37a1.68,1.68,0,0,1,1.74-1.59h10.53a29.82,29.82,0,0,0-8.21-2.06c-28.7-3.36-39-1.14-42.57,1.15a42.24,42.24,0,0,1-14.75,5.9C103,12.09,69.9,16.1,39.88,7.48c-14.92-4.28-26,3-32.66,15.06H198.4A26.31,26.31,0,0,0,196,12.93,1.83,1.83,0,0,1,194.9,13.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.43,45.38a74,74,0,0,0,.78,21.35l177.07,5.9a75.58,75.58,0,0,0,12.3-17.1Zm70,15.23H67a1.6,1.6,0,1,1,0,3.18H46.81a1.6,1.6,0,1,1,0-3.18H50.3a1.6,1.6,0,1,1,0-3.18H47.81a1.6,1.6,0,1,1,0-3.18H68a1.6,1.6,0,1,1,0,3.18h2.48a1.6,1.6,0,1,1,0,3.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M198.41,22.65,5.09,26.93A64.93,64.93,0,0,0,.46,45.14H195a69.61,69.61,0,0,0,2.81-11.6A50.25,50.25,0,0,0,198.41,22.65Zm-158.7,14H36.22a1.6,1.6,0,1,1,0,3.18H16.06a1.6,1.6,0,1,1,0-3.18h3.49a1.6,1.6,0,1,1,0-3.18H17.05a1.6,1.6,0,1,1,0-3.18H37.22a1.6,1.6,0,1,1,0,3.18h2.49a1.6,1.6,0,1,1,0,3.18Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 115.92,
    cy: 130.85,
    rx: 13.13,
    ry: 2.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 146.42,
    cy: 140.21,
    rx: 23.68,
    ry: 1.94
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 51.34,
    cy: 137.26,
    rx: 23.68,
    ry: 2.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 87.44,
    cy: 122.51,
    rx: 17.82,
    ry: 2.95
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 92.42,
    cy: 147.05,
    rx: 14.26,
    ry: 2.95
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M100.76,52.4a61.51,61.51,0,0,0-2.68-8.46h0q-.06-.26-.14-.52C96.3,37.8,94,37.31,94,37.31l-8.11-1.74a.63.63,0,0,1,.17.16l-.13,0a3.18,3.18,0,0,1-.71-1.54c0-.08,0-.17,0-.26a5.7,5.7,0,0,0-.46-8.57l-.26-.19a1.29,1.29,0,0,0,.11-1.54,5.36,5.36,0,0,0-3.45-2.58A5.86,5.86,0,0,0,77.81,21a12.11,12.11,0,0,0-1.76.81A9.87,9.87,0,0,0,73,23.67a.9.9,0,0,0-.31.74,2,2,0,0,0,.31.54,1.63,1.63,0,0,1,0,1.35,13.1,13.1,0,0,0-.5,1.3,1.36,1.36,0,0,0,.27,1.3,5.73,5.73,0,0,0,.51.35,2.66,2.66,0,0,1,.48.54l1,1.3a13.36,13.36,0,0,1,1.2,1.83,8.9,8.9,0,0,0,.74,1.4,2.07,2.07,0,0,0,.32.34l-.09,0a1.45,1.45,0,0,0,1.07.43h0a.29.29,0,0,0,.2-.08v.17c0,.62,0,1.29,0,1.91l-.07,0a.65.65,0,0,0-.7.07l-7.46,6a9.83,9.83,0,0,0-1.4,6.05l-1.31,5.75s-1.63,4.87-.38,8.36,2,5.47,2,5.47.5,4,1.26,4.28,1.08.5,1.08.5l.15.95h0l.14.25c.55,1,2.59,4.33,3.77,4a15.13,15.13,0,0,1,.19,2.77l1.17,7.86a11.56,11.56,0,0,1,.77,3.26,6.21,6.21,0,0,0,1,2.72,5.19,5.19,0,0,0-.5,3.66c.48,2.09,1.08,11.74,1.08,11.74l.87,2.34,0,2.74a2.62,2.62,0,0,1-.54,1.22c-.57.61-.52,1.32-1.89,2.16s-2.23,1.16-2.23,2.27a2.93,2.93,0,0,1,0,.46c-.13.82-.37,1.26,2.14,1.5a6.61,6.61,0,0,0,4.91-1.64s.43-.79,2.47-1.1c0,0,.7,0,.73-.65,0-.21,0-.62,0-1.07a6.58,6.58,0,0,0-.22-1.9,4.14,4.14,0,0,1-.46-1.23h.57a24.81,24.81,0,0,0,0-6.52,10.57,10.57,0,0,1-.05-4.38L85,98.08A1.93,1.93,0,0,1,84.88,96c.55-1.32,0-7.83,0-7.83s.2-2.34.78-2.89,0-3.43,0-3.58l1,3.45s.45,6.86,1.41,8.11l.28,3.11s2,2.86,1.58,4.4.4,7.11.4,7.11v5.7s-.88,2.29.35,3.11l.52,0c-.17.16-.31.41-.51.62a4.72,4.72,0,0,0-.44,2c-.06.67-.08,1.25-.08,1.25a2.06,2.06,0,0,0,1.51.9c1,.06,4.23,2.53,4.23,2.53a38.42,38.42,0,0,0,4-.17h0a1.09,1.09,0,0,0,.63-.51,1.31,1.31,0,0,0,.15-.94,2.35,2.35,0,0,0-1.35-1.48c-2.14-1.13-2.46-2.19-2.46-2.19l-1.41-2.11h.2a9,9,0,0,1,1.41-4.75l-.1-11.07s.63-3.81-.45-5.87c0,0-.09-2.19.63-2.86s-1-7.46-1-7.46-.35-3.64-.76-7h0c1.7,1.61,3.46-4.19,3.75-5.22h0l0-.08,0-.07h0s-.38-1.34-.1-1.07,1-.75,1-.75-.1-5.55,1.08-8.34S100.76,52.4,100.76,52.4ZM95.7,55.93v0c.17,3.39,0,10.61,0,10.61s-.23.93-.48,2L95,61.68h0l-.17-6.47ZM74,53.6s.85,10.69,0,12.24a8.08,8.08,0,0,0-.62,2.11,7.77,7.77,0,0,1-.67-3.41c.28-1.19-.55-4.33-.55-4.4a7.44,7.44,0,0,1,.52-3c.6-1.28.21-1.83.21-1.83S73.44,53.19,74,53.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M76.13,77.68C75.38,81,72.42,76,71.74,74.82l-.14-.25.32-1.51,1.7-.7a4.75,4.75,0,0,1,.76.5A4.59,4.59,0,0,1,76.13,77.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.11,72.32a.23.23,0,0,1,0,.07.37.37,0,0,1,0,.08c-.29,1-2,6.78-3.69,5.18-1.83-1.74-.94-5.78-.94-5.78h0l3.84-.39.76.78h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M96.89,100.65l.1,11a9,9,0,0,0-1.38,4.71l-5,.2c-1.21-.81-.35-3.08-.35-3.08V107.8s-.77-5.53-.4-7.06-1.55-4.36-1.55-4.36l-.27-3.09c-.94-1.23-1.38-8-1.38-8l-1-3.44c0,.15.55,3,0,3.55s-.77,2.86-.77,2.86.54,6.47,0,7.78A1.93,1.93,0,0,0,85.06,98l.1,6.72a10.5,10.5,0,0,0,0,4.34,24.7,24.7,0,0,1,0,6.47H79.89l0-2.74L79,110.51s-.59-9.58-1.06-11.65a5.21,5.21,0,0,1,.49-3.63,6.17,6.17,0,0,1-.94-2.69,11.51,11.51,0,0,0-.76-3.23l-1.15-7.8a15.16,15.16,0,0,0-.57-4.44c-.67-2.22-1.65-5.14-1.65-5.14l1.11.1,5.63.5s13.68-.92,14.29-.16a2.57,2.57,0,0,1,.26.8c.61,2.76,1.43,11.4,1.43,11.4s1.65,6.74.94,7.41-.62,2.84-.62,2.84C97.51,96.86,96.89,100.65,96.89,100.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.33,119.74c0,.61-.72.65-.72.65-2,.31-2.43,1.09-2.43,1.09a6.42,6.42,0,0,1-4.81,1.63c-2.46-.24-2.22-.68-2.09-1.49a3.08,3.08,0,0,0,0-.46c0-1.11.85-1.43,2.18-2.27s1.3-1.54,1.85-2.15A3.4,3.4,0,0,0,80,115c.63-1.09,2.22.17,2.22.17.08.39,2.44.33,2.44.33a5.22,5.22,0,0,0,.48,1.33,6.55,6.55,0,0,1,.22,1.88C85.34,119.13,85.34,119.53,85.33,119.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.33,119.74c0,.61-.72.65-.72.65-2,.31-2.43,1.09-2.43,1.09a6.42,6.42,0,0,1-4.81,1.63c-2.46-.24-2.22-.68-2.09-1.49,1.1.27,3.2.65,4.43,0,1.7-.92,2.93-1.57,2.93-1.57l2.69-1.36C85.34,119.13,85.34,119.53,85.33,119.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M100.4,123a1.06,1.06,0,0,1-.61.51h0a37,37,0,0,1-4,.17s-3.18-2.46-4.15-2.52a2,2,0,0,1-1.48-.89s0-.57.08-1.24a4.73,4.73,0,0,1,.44-1.95c.43-.44.52-1,1.48-.67,0,0,1.37-2.41,3-.55l1.67,2.53s.31,1,2.43,2.18a2.34,2.34,0,0,1,1.33,1.47A1.3,1.3,0,0,1,100.4,123Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.4,123l-.61.51h0a37,37,0,0,1-4,.17s-3.18-2.46-4.15-2.52a2,2,0,0,1-1.48-.89s0-.57.08-1.24a6.87,6.87,0,0,1,2.86,1.37,12.14,12.14,0,0,0,2.47,2s3.46-.33,5-.38A1.3,1.3,0,0,1,100.4,123Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.94,36.88,82.38,41.7s-5.52-.41-4.56-2a9.16,9.16,0,0,0,.52-4.08c0-1.46-.19-2.7-.19-2.7s7.74-3.85,7.15-.26a5.91,5.91,0,0,0,0,2.05A2.69,2.69,0,0,0,86.94,36.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.31,32.62a5.91,5.91,0,0,0,0,2.05,5.68,5.68,0,0,1-4.05,1.69c-1,0-2.18-.86-3-1.36,0-1.46,0-2.12,0-2.12S85.9,29,85.31,32.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.94,30.36a5.7,5.7,0,1,1-2.15-4.46A5.7,5.7,0,0,1,86.94,30.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.7,73.17c-1.42,3.38-10.56,3.45-10.56,3.45V72.93l-.55,0a12.69,12.69,0,0,1-.34,3.63c-7.22,1-9-3.1-9-3.1L74.52,72l5.63.5s13.68-.92,14.29-.16A2.57,2.57,0,0,1,94.7,73.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M84.14,76.17V72.49l-.55,0a12.73,12.73,0,0,1-.34,3.63c-5.43.77-7.77-1.37-8.6-2.48a3.38,3.38,0,0,1-.38-.61l2.21-12.41L77,42.33l.79-3.2L78,37.59v0h0l.56.24,3.36,1.45,3.82-2.88.06,0,.19-.14.32.25.79.63L89.6,53.34S94,65.85,94.78,70.91c0,.2.06.39.08.57C95.4,76.09,84.14,76.17,84.14,76.17Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 82.33,
    cy: 39.62,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 82.48,
    cy: 42.58,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 82.8,
    cy: 47.38,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 83.34,
    cy: 52.55,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 83.66,
    cy: 57.4,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 83.99,
    cy: 62.56,
    r: 0.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-8",
    cx: 83.86,
    cy: 67.67,
    r: 0.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.19,62.39s-.36,4.75-1,6.13-1,5.26-1,5.26l-1.55-.17a3.37,3.37,0,0,1-.38-.61l2.21-12.41L77,42.33l.79-3.21L78,37.59h0a.62.62,0,0,1,.55,0l.07,0-.06.19a29.66,29.66,0,0,0-.83,5.37s.87,6.37,1,9.33S78.19,62.39,78.19,62.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M74.39,72.87l-.06.12a5.56,5.56,0,0,1-2.58,1.83l-.14-.25.32-1.51,1.7-.7A4.74,4.74,0,0,1,74.39,72.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M70.27,48.62l-1.41.84-1.28,5.7S66,60,67.21,63.46s2,5.44,2,5.44.49,3.93,1.24,4.25,1.06.49,1.06.49l.15.94a5.86,5.86,0,0,0,2.72-1.88c.71-1.2-.52-4.19-.52-4.19S72.74,66,73,64.77s-.54-4.3-.54-4.36a7.39,7.39,0,0,1,.52-3c.6-1.27.2-1.81.2-1.81L72.82,52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M94.81,72.1s-3.73,1.41-4.91.17-1.06-7-1.06-7S87.7,54.6,87,52.85s-.35-14.39-.35-14.39a7.66,7.66,0,0,0-.9-2.06l-.09-.07.14,0,.51.11.79.63L89.6,53.35S94,65.86,94.78,70.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99.11,72.47h0c-.47.06-4.61.56-4.63-.3a2.52,2.52,0,0,1,0-.3l3.84-.39.76.78h0l0,.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M95.13,42.91l2.72,1.42a60.51,60.51,0,0,1,2.63,8.39s1.68,6.75.52,9.52S100,70.52,100,70.52s-.67,1-.94.74.1,1.06.1,1.06-4.65.62-4.67-.3a47.73,47.73,0,0,1,1.07-5.28s.3-10.39-.12-12S95.13,42.91,95.13,42.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M87,54s-1.53,3.75-2,4,.1,1.23.1,1.23S87.88,55.31,87,54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86.1,40.82c0-.07-1.83,1.81-2.32,2.09S85.58,42.9,86.1,40.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81,53.68s-2.81,1.82-2.44,2.54S81,53.68,81,53.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86.07,80.25a15.07,15.07,0,0,0,6.12,1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80.32,84s2.22,2.79,3.23,2.86S80.32,84,80.32,84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M83.43,94.89c-.1,0-1.26,2.52-2.44,2.59S83.43,94.89,83.43,94.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.73,100.3s2.2-.49,2.69,1.09C96.42,101.38,96.27,100.89,93.73,100.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.25,109.33s2.67-.54,3.23.2S92.25,109.33,92.25,109.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.7,110.59s-2.71.54-2.62.89,2.9.3,3-.25a.52.52,0,0,0-.37-.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M91.36,112.94s4.46-.54,4.19.39S91.36,112.94,91.36,112.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M68,58c0,.07,2.94.47,3.33,1.41A25.06,25.06,0,0,0,68,58.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M72.1,65.61s-2.42.77-2.25,1.92S69.61,67,72.1,65.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M71,71.48s.88-1.21,1.72-1S71,71.48,71,71.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.79,25.91a1.37,1.37,0,0,1-.28.21,3.26,3.26,0,0,0-1.22,1.76A3.73,3.73,0,0,1,82,29.61c-.8.49-1.86.31-2.7.73A2.09,2.09,0,0,0,78.2,32.4a6,6,0,0,0,.24.95,6.74,6.74,0,0,1,.25,2.05.35.35,0,0,1,0,.06,5.7,5.7,0,1,1,6.11-9.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M84.64,24.19a5.26,5.26,0,0,0-3.39-2.56A5.69,5.69,0,0,0,78,21.56a12.08,12.08,0,0,0-1.72.81,9.74,9.74,0,0,0-3,1.83.92.92,0,0,0-.3.74,2.05,2.05,0,0,0,.3.53,1.62,1.62,0,0,1,0,1.34,12.31,12.31,0,0,0-.49,1.29A1.36,1.36,0,0,0,73,29.4a4.83,4.83,0,0,0,.5.35,2.62,2.62,0,0,1,.47.54l.94,1.29a13.06,13.06,0,0,1,1.18,1.81,8.63,8.63,0,0,0,.73,1.38,1.58,1.58,0,0,0,1.32.71.26.26,0,0,0,.21-.1.28.28,0,0,0,0-.13,6.7,6.7,0,0,0-.25-2,5.91,5.91,0,0,1-.24-.95A2.1,2.1,0,0,1,79,30.19c.84-.42,1.9-.24,2.7-.73A3.71,3.71,0,0,0,83,27.72,3.28,3.28,0,0,1,84.21,26,1.23,1.23,0,0,0,84.64,24.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M82.09,117.41s.87,1.11.65,1.74S82.09,117.41,82.09,117.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.89,120.19s.19-1.49,1-1.5a2.6,2.6,0,0,1,1.41.15c.59.23,1.15.58,1,.64s-1-.85-1.89-.39A6.23,6.23,0,0,0,93.89,120.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M79.49,41.13l2.44-1.71s-3.57-2.11-4-1.81-.72,3-.72,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M79.48,41l2.44-1.74s-3.57-2.11-4-1.81-.72,3.11-.72,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M79.48,41l2.44-1.74s-3.57-2.11-4-1.81-.72,3.11-.72,3.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M78.32,37.48l-.07,0a.63.63,0,0,0-.69.07l-7.33,5.94a9.84,9.84,0,0,0-1.37,6l4.32,6.12s.49-2.07,1.09-1.68c0,0,.84,10.62,0,12.15s-1.21,7.26-1.21,7.26l2.84.32s.3-3.88,1-5.26,1-6.13,1-6.13.6-6.9.5-9.87-1-9.33-1-9.33A28.29,28.29,0,0,1,78.32,37.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.62,40l-3-1.13s3.88-4.25,4.36-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M85.62,39.9l-3-1.13s3.88-4.25,4.36-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M85.62,39.9l-3-1.13s3.88-4.25,4.36-1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.52,36.29a.17.17,0,0,1,.13,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M85.82,36l8.08,1.74s2.22.49,3.83,6.07-2.2,12.42-2.2,12.42l-.84-.71.42,16.29s-3.73,1.41-4.91.17-1.06-7-1.06-7S88,54.3,87.28,52.55s-.35-14.39-.35-14.39S86.27,35.89,85.82,36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.21,46.38a46.23,46.23,0,0,0,.25,8.79,47.88,47.88,0,0,0,1.4,6.76l-.73-15S93.55,46.05,93.21,46.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.22,42.13c.2.12,1.06,2.17.67,3S92.22,42.13,92.22,42.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.6,24.19a4.46,4.46,0,0,0-1.78-1.86,4.22,4.22,0,0,1,1.33,1.57,1.24,1.24,0,0,1-.43,1.78,3.27,3.27,0,0,0-1.22,1.76,3.79,3.79,0,0,1-1.27,1.74c-.8.48-1.86.31-2.7.73A2.11,2.11,0,0,0,77.41,32a5.94,5.94,0,0,0,.24.94A6.75,6.75,0,0,1,77.9,35a.28.28,0,0,1,0,.13.25.25,0,0,1-.21.1,1.2,1.2,0,0,1-.61-.11,1.42,1.42,0,0,0,1,.41.21.21,0,0,0,.23-.23,6.7,6.7,0,0,0-.25-2.05,5.74,5.74,0,0,1-.24-.95A2.1,2.1,0,0,1,79,30.2c.84-.42,1.9-.24,2.7-.73a3.71,3.71,0,0,0,1.27-1.74A3.29,3.29,0,0,1,84.15,26,1.24,1.24,0,0,0,84.6,24.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M134.3,46.1a7.15,7.15,0,0,1-5.73-3.82,3.84,3.84,0,0,1-.58-1.63,1.88,1.88,0,0,1,.07-.39,4.06,4.06,0,0,0,.17-.6,1,1,0,0,0,0-.24h0a1.44,1.44,0,0,0-.52-1.17c-.32-.3-.72-.52-1.06-.82a5,5,0,0,1-1.37-3.75v-.07c0-.59.06-1.19.05-1.78a7.5,7.5,0,0,0,0-1,3.33,3.33,0,0,0-1.08-2.23c-1.72-1.4-4.61.06-6.39-1.26-.43-.32-.78-.8-1.31-.92a2.2,2.2,0,0,0-1.2.16c-1.31.43-2.78,1-3.29,2.27-.29.73-.21,1.56-.48,2.29a11.47,11.47,0,0,1-.75,1.39,2.17,2.17,0,0,0-.28,1.16,1.3,1.3,0,0,0,.09.62,1.57,1.57,0,0,0,.43.61,2,2,0,0,1-.25.41c-.33.41-.85.7-1.2,1.11a2.61,2.61,0,0,0-.3,2.65c.32.88.89,1.68,1.29,2.54a1.36,1.36,0,0,1,.13,1.16,3.31,3.31,0,0,1-.58.67,2.12,2.12,0,0,0-.52,1.17c-3.93.9-3.93,4.05-3.93,4.05h0L103.54,54s-.34.9-.74,2.09l-2.51-.45L102,58.51a9.23,9.23,0,0,0-.49,2.85s-.78,3.66.61,4.3L105.21,67a1.82,1.82,0,0,0,.42.19l.12.06a.33.33,0,0,0,.29,0h0a.41.41,0,0,0,.17,0,.35.35,0,0,0,.15-.17.05.05,0,0,1,0,0l.92-.27.78.92c.35.25.7.46,1,.65l-1.2,11.94s-.19,15.88-.78,19.5a10.14,10.14,0,0,0-.14,2.88l0,0c.14,1,.52,1.22.52,1.22h0a10.27,10.27,0,0,1,.63-1.35v.26c0,1.35-.05,3.23-.19,4.46-.24,2.09.61,9,.61,9l.29,6.28a5.81,5.81,0,0,1-.72,3.06,14.44,14.44,0,0,0-1.65,3.8.77.77,0,0,0,0,.13h0l-1.5,1.8s-.58.9.74,1.27a7.07,7.07,0,0,0,2.92-.23,2,2,0,0,0,1.51-1.9,6.72,6.72,0,0,1,1.24-2.37l.25,1.45,1.65.41.21-4a1.75,1.75,0,0,0,.11-.7h0c.32-2.82-.76-2.57-.76-2.57a.15.15,0,0,1,.05.1l-.05-.1h0a7.13,7.13,0,0,1-.35-3.49s.87-6.28,1.17-7.94a57.59,57.59,0,0,0,.05-7.15,2.53,2.53,0,0,0,0-.26c2.55,0,5.68-.12,7.88-.33v.26l-.4,14.84a8.14,8.14,0,0,1-.57,2.76.15.15,0,0,1,0,.05,12,12,0,0,0-.8,3.89l-.19,4.71v.13h0c-.33.13-.85.49-.86,1.55,0,1.55,2.71,1,2.71,1,2.73,0,2.75-2.84,2.75-2.84s.09-2.6.22-4.35-.41-1.36-.41-1.36l0,5v-4.31l0-.63v0h0v-.13l.34-5.11s2.51-8.52,2.9-10.16a38.31,38.31,0,0,0,.07-6.6,1.53,1.53,0,0,0,0-.26c.78-.07,1.47-.08,1.74-.08h.13s-.13-13.69-.46-18.84-.84-9.88-2.14-11.3c-.79-.86-1.88-3.51-2.62-5.47a27.36,27.36,0,0,0,4.81,1.57c4.12.86,3.55-2.71,3.55-2.71l-.42-6.76h0a34.46,34.46,0,0,0-.45-5.28,15.54,15.54,0,0,0-1.06-3.84c.45-.17.89-.36,1.32-.55,1.12-.49,2.38-1.19,2.54-2.4h-.05A1.55,1.55,0,0,0,134.3,46.1Zm-25.51,9.77h0c0,.7,0,1.91-.06,3.25l-1.31-1.74,1.31-2.13Zm18.06,6.18-2.18-.7A9.77,9.77,0,0,1,126,59.69l.19-.17h-.07l.1-.1h.06l-.1.1.12,0a3.71,3.71,0,0,0,.74,1.49c.78.85-.21,1.07-.21,1.07Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "113.61 124.87 113.36 129.7 111.73 129.29 111.39 127.28 113.61 124.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "113.61 124.87 113.36 129.7 111.73 129.29 111.39 127.28 113.61 124.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M119.58,130.34l2.48.51,1.84-1.62v-4.57l0-.62v0h0v-.13l.34-5.08s2.48-8.46,2.86-10.08a38.31,38.31,0,0,0,.07-6.55c0-.79-.07-1.31-.07-1.31l-5.47-1.32-.12,4.21-.4,14.73a8.16,8.16,0,0,1-.56,2.74l0,.05a12,12,0,0,0-.79,3.86l-.19,4.68v.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123.93,123.88V124h0v-.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.58,130.34l2.48.51,1.84-1.62v-.39a.52.52,0,0,1-.26.42l0,0a4.94,4.94,0,0,1-2.78.55l-1-.08a.91.91,0,0,0-.26.06v.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M123.6,129.4h0a.52.52,0,0,0,.27-.45l0-4.92s.53-.38.4,1.35-.21,4.32-.21,4.32,0,2.82-2.71,2.82c0,0-2.69.51-2.67-1s1.11-1.6,1.11-1.6l1,.08A4.93,4.93,0,0,0,123.6,129.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M106.67,129.29c.06,1.11,3.33.47,3.33.47l2.2-4.27s1.84-1.41.92-2.65l-.13-.21h0l-.05-.1h0a7,7,0,0,1-.33-3.45s.85-6.24,1.15-7.88a57.85,57.85,0,0,0,.05-7.11c0-.89-.05-1.48-.05-1.48l-5.43-1.45v1.62c0,1.34-.05,3.21-.19,4.43-.23,2.07.6,8.93.6,8.93l.29,6.24a5.78,5.78,0,0,1-.7,3,14.6,14.6,0,0,0-1.63,3.78A.76.76,0,0,0,106.67,129.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106.67,129.29c.06,1.11,3.33.47,3.33.47l2.2-4.27s1.84-1.41.92-2.65l-.13-.21a10.61,10.61,0,0,1-.74,2.27s-1.82,3.63-2.39,4.47-3.09-.16-3.18-.19A.77.77,0,0,0,106.67,129.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M112.92,122.51s1.07-.25.75,2.55h0a1.8,1.8,0,0,1-.85,1.6,6.11,6.11,0,0,0-2.56,3.55h0a1.93,1.93,0,0,1-1.49,1.88,7,7,0,0,1-2.88.23c-1.3-.36-.73-1.26-.73-1.26l1.5-1.77s2.61,1,3.18.19,2.39-4.46,2.39-4.46S113.24,122.75,112.92,122.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M121.67,100l-.12,4.2c1.46-.14,2.5-.34,2.68-.62.39-.6,1.78-.85,3-1,0-.79-.07-1.31-.07-1.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M108.31,103.27a2,2,0,0,1,.6-.72c.58-.32.51,2.05.51,2.05s1.92,0,4.37,0c0-.89-.05-1.48-.05-1.48l-5.43-1.45S108.33,102.32,108.31,103.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M107.7,103.83s.64-1.74,1.22-2.06.51,2.05.51,2.05,14.1.13,14.81-1,4.81-1,4.81-1-.13-13.59-.45-18.71-.83-9.81-2.11-11.22c-.83-.91-2-3.86-2.74-5.83-.4-1.07-.66-1.86-.66-1.86L109.62,65l-.11,1.09-1.43,14.29s-.19,15.77-.77,19.36S107.7,103.83,107.7,103.83Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.14,102.86c.7-1.09,4.81-1,4.81-1s-.13-13.59-.45-18.71-.83-9.81-2.11-11.22c-.83-.92-2-3.86-2.74-5.83-.33-.9-.57-1.6-.64-1.8l1-.06s.26.78.66,1.86c.73,2,1.91,4.92,2.74,5.83,1.28,1.41,1.8,6.09,2.11,11.22s.45,18.71.45,18.71-4.1-.06-4.81,1c-.6.93-11,1-14,1C114.08,103.82,122.6,103.7,123.14,102.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.82,101.77c.26-.14.39.26.45.74a10.05,10.05,0,0,0-.61,1.31s-.37-.2-.52-1.22A2.38,2.38,0,0,1,107.82,101.77Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M111.85,31.34c-.93,1.27,0,3.08-1,4.31-.33.41-.84.7-1.18,1.1a2.61,2.61,0,0,0-.3,2.63c.31.87.87,1.67,1.27,2.52a1.35,1.35,0,0,1,.13,1.15,3.25,3.25,0,0,1-.57.67,2.41,2.41,0,0,0-.31,2.56,8.28,8.28,0,0,0,1.66,2.29,1.13,1.13,0,0,0,1.64.38,6.46,6.46,0,0,0,2.94-8.43c-.54-1.3-1.44-2.54-1.45-3.91,0-1.09.56-2.13.66-3.21.12-1.32-.66-3.4-2.25-4C113.2,30.25,112.33,30.68,111.85,31.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.85,31.34c-.93,1.27,0,3.08-1,4.31-.33.41-.84.7-1.18,1.1a2.61,2.61,0,0,0-.3,2.63c.31.87.87,1.67,1.27,2.52a1.35,1.35,0,0,1,.13,1.15,3.25,3.25,0,0,1-.57.67,2.41,2.41,0,0,0-.31,2.56,8.28,8.28,0,0,0,1.66,2.29,1.13,1.13,0,0,0,1.64.38,6.46,6.46,0,0,0,2.94-8.43c-.54-1.3-1.44-2.54-1.45-3.91,0-1.09.56-2.13.66-3.21.12-1.32-.66-3.4-2.25-4C113.2,30.25,112.33,30.68,111.85,31.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.19,77.54a12.39,12.39,0,0,0-5.25,1.81,36,36,0,0,1-5,2.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M121,81.93a7.69,7.69,0,0,0-4.84,2.36c-.45.48-.84,1-1.32,1.48a5.85,5.85,0,0,1-2.6,1.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M121.41,85.28a8.47,8.47,0,0,0-3.89,2.35c-.29.31-.55.64-.83.95a15.37,15.37,0,0,1-5.83,3.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M121.25,38.89a38.29,38.29,0,0,0,.38,4.45,5.83,5.83,0,0,0,.77,2.41c1,1.22-5,2.85-5,2.85l-3.56-2.76s2.82-2.6,1.51-5.13S121.25,38.89,121.25,38.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109.51,66.07h14.23c-.4-1.07-.66-1.86-.66-1.86L109.62,65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M108.59,65.81h15.21a5.28,5.28,0,0,1,.61-4A8.92,8.92,0,0,1,126,59.71l.1-.1,5.31-1.18.29-.06s0-9.66-3.38-11a20,20,0,0,1-5.47-3.12l-4.7,1.45L114.7,44c-1.11,1.2-4.06.73-4.06.73-4.83.55-4.83,4.19-4.83,4.19s2.82,6.58,3,6.58S108.59,65.81,108.59,65.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M113.85,59.67s-3.1-.69-4.16-1.89"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129.49,56.07,125.89,59a6.13,6.13,0,0,0,.12.7l.1-.1,5.31-1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M119.75,64.79s.79.44,2,1h2.07a5.28,5.28,0,0,1,.61-4l-3.64-1.18C122,61.75,119.75,64.79,119.75,64.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M108,47.74l-2.14,1.15-2.09,5.3s-2.18,5.81-2,7.35c0,0-.77,3.63.6,4.27l3.56,1.61a.33.33,0,0,0,.43-.46c-.51-1-1.07-2.47-.17-3.29l-1-2.14,3.71-6.07,1.24-2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.7,58.46c.18.75.81,1.92,2.88,2.35l2.27,1.86,2.41,1.09,1,.44.42-3-.95-.52-1.1-.6s-2.49-4.51-6.44-2.62A.87.87,0,0,0,112.7,58.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M112.83,58.21c.18.76.81,1.92,2.88,2.35L118,62.42l2.41,1.09,1,.45.42-3-.95-.52-1.1-.6s-2.49-4.51-6.44-2.61A.87.87,0,0,0,112.83,58.21Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 117.28,
    cy: 37.29,
    r: 5.51
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-13",
    cx: 117.28,
    cy: 37.16,
    r: 5.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.69,48.94,119,45.72s2.43-1,2.6-2.12,2.32,1.33,1.86,2.15A30.5,30.5,0,0,1,120.69,48.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M120.69,48.68,119,45.46s2.43-1,2.6-2.12,2.32,1.33,1.86,2.15A30.7,30.7,0,0,1,120.69,48.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M107.13,57l9.16,12.31s-3.38,1.84-8-1.45l-2-2.39-5.73-9.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M105.32,63.7l.83,0s5.09-4.94,6.35-2.44-3.17,4.84-3.17,4.84L108,66.8l-1.75.52-1.12-1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106.55,66.37a1.25,1.25,0,0,1,0,.86.35.35,0,0,1-.15.17.39.39,0,0,1-.17,0,1.75,1.75,0,0,1-1.15-.57,5.25,5.25,0,0,1-.74-1.08,2,2,0,0,1-.38-1.28,1.87,1.87,0,0,1,.95-1.11c.84-.56.87.09,1.06.81S106.36,65.65,106.55,66.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M106.43,66.37a1.26,1.26,0,0,1,0,.86.35.35,0,0,1-.15.17.39.39,0,0,1-.17,0,1.75,1.75,0,0,1-1.15-.57,5.19,5.19,0,0,1-.75-1.08,2,2,0,0,1-.38-1.28,1.87,1.87,0,0,1,.95-1.11c.85-.56.87.09,1.06.81S106.23,65.65,106.43,66.37Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "108.85 55.47 109.28 54.75 108.91 56.09 108.85 55.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.4,63.51l1,.45.42-3-.95-.52C121.5,61.17,120.93,62.56,120.4,63.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M124.34,60s-3.17.19-4.52-.67"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.95,62A8.93,8.93,0,0,1,125.54,60a4.27,4.27,0,0,1,.47-.25l4.94-1,.29-.06s0-9.66-3.37-11a20.54,20.54,0,0,1-5.33-3l.38-.12a19.94,19.94,0,0,0,5.47,3.12c3.42,1.32,3.37,11,3.37,11h-.51l-5.06,1-.28.27A9.8,9.8,0,0,0,124.28,62a5.36,5.36,0,0,0-.42,4.05h-.52A5.33,5.33,0,0,1,123.95,62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.44,45l.25,0a8.84,8.84,0,0,0,1,.09A9.53,9.53,0,0,1,110.44,45Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.69,46l-3.13-1.58.17-.17L118,45.89Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M129.61,55.81l2.09,2.56.43,7s.55,3.55-3.5,2.69a37.42,37.42,0,0,1-8.76-3.5s2.27-3,1-4.19l5.81,1.88s1-.21.21-1.07a4.81,4.81,0,0,1-.91-2.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130.56,63.17l1.15,1.32A1.66,1.66,0,0,1,130.56,63.17Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "128.59 62.95 130.39 65.26 129.49 65.47 128.59 62.95"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M110.69,34.63a1.84,1.84,0,0,1,.19-1.5,11.89,11.89,0,0,0,.74-1.38c.26-.73.18-1.55.47-2.27.51-1.26,2-1.83,3.24-2.27a2.18,2.18,0,0,1,1.18-.16c.52.12.86.6,1.29.92,1.76,1.31,4.61-.13,6.31,1.25a3.3,3.3,0,0,1,1.06,2.21,19.55,19.55,0,0,1,0,2.52,5.18,5.18,0,0,0,1.35,4c.33.29.72.51,1,.82a1.43,1.43,0,0,1,.52,1.17,4,4,0,0,1-.17.59,3,3,0,0,0,.51,2.27,7.07,7.07,0,0,0,5.65,3.79c-.16,1.2-1.4,1.89-2.5,2.38a9.83,9.83,0,0,1-4.42,1.16,3.54,3.54,0,0,1-3.41-2.58c-.09-.52-.08-1.15-.52-1.43-.27-.17-.62-.12-.92-.25a1.62,1.62,0,0,1-.77-1.09,9.8,9.8,0,0,1-.46-2.79c0-1.12.13-2.35-.51-3.27s-1.64-1.29-2.32-2.08A4.1,4.1,0,0,0,115.9,35C114.48,34.76,111.54,36.69,110.69,34.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M110.69,34.38a1.84,1.84,0,0,1,.19-1.5,11.88,11.88,0,0,0,.74-1.38c.26-.73.18-1.55.47-2.27.51-1.27,2-1.83,3.24-2.27a2.18,2.18,0,0,1,1.18-.16c.52.12.86.6,1.29.92,1.76,1.31,4.61-.13,6.31,1.25a3.3,3.3,0,0,1,1.06,2.21,19.52,19.52,0,0,1,0,2.51,5.18,5.18,0,0,0,1.35,4c.33.29.72.51,1,.82a1.43,1.43,0,0,1,.52,1.17,4,4,0,0,1-.17.59,3,3,0,0,0,.51,2.27,7.08,7.08,0,0,0,5.64,3.79c-.16,1.2-1.4,1.89-2.5,2.38a9.85,9.85,0,0,1-4.42,1.16,3.54,3.54,0,0,1-3.41-2.58c-.09-.52-.08-1.15-.52-1.43-.27-.17-.62-.12-.92-.25a1.62,1.62,0,0,1-.77-1.09,9.79,9.79,0,0,1-.46-2.79c0-1.12.13-2.35-.51-3.27s-1.64-1.29-2.32-2.08a4.1,4.1,0,0,0-2.34-1.74C114.48,34.5,111.54,36.44,110.69,34.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.61,48.54,117.77,46s-2.16-1.17-2.42-2.17-2,.47-1.81,1.37S114.61,48.54,114.61,48.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M114.73,48.16l3.16-2.56s-2.16-1.17-2.41-2.17-2,.47-1.81,1.37S114.73,48.16,114.73,48.16Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 118.01,
    cy: 47.74,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 118.01,
    cy: 49.13,
    r: 0.25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 118.01,
    cy: 50.53,
    r: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112,30.81c.25-.69.2-1.46.43-2.15a2.35,2.35,0,0,0-.27.49c-.29.72-.21,1.55-.47,2.27l0,0A4,4,0,0,0,112,30.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.9,48.09a9.85,9.85,0,0,1-4.42,1.16,3.54,3.54,0,0,1-3.41-2.58c-.09-.52-.08-1.16-.52-1.43-.27-.17-.62-.12-.92-.25a1.62,1.62,0,0,1-.77-1.09,9.79,9.79,0,0,1-.46-2.79c0-1.12.13-2.35-.51-3.27s-1.64-1.29-2.32-2.08A4.11,4.11,0,0,0,116.24,34c-1.41-.19-4.36,1.74-5.2-.32a1.62,1.62,0,0,1,.05-1.19l-.17.31a1.85,1.85,0,0,0-.19,1.5c.84,2.06,3.78.12,5.2.32a4.14,4.14,0,0,1,2.34,1.74c.68.79,1.73,1.22,2.32,2.08s.49,2.15.51,3.27a9.78,9.78,0,0,0,.46,2.79,1.62,1.62,0,0,0,.77,1.09c.29.12.65.08.92.25.45.27.44.91.52,1.43a3.55,3.55,0,0,0,3.41,2.58,9.87,9.87,0,0,0,4.42-1.16c1-.45,2.14-1.07,2.44-2.09A5.29,5.29,0,0,1,131.9,48.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M162.74,57.93a41,41,0,0,0-5.1-2.65l-.08-.05a3.07,3.07,0,0,1-.93-1.18,2.43,2.43,0,0,1,0-.25.11.11,0,0,0,0,0,5.57,5.57,0,0,1,1.62-3l1.94-2.28a2.25,2.25,0,0,0,.5-.79,1.83,1.83,0,0,0,.05-.49V47c0-.57,0-1.14,0-1.7s-.14-1.12-.64-1.22c-.26-.05-.6,0-.74-.17a.42.42,0,0,1,0-.29.1.1,0,0,0,0,0v0a6.58,6.58,0,0,0,.18-1.17,1.59,1.59,0,0,0-.08-.59c-.29-.82-1.28-1.16-2.15-1.32a3.77,3.77,0,0,1-2.4-1,7.08,7.08,0,0,0-.48-.66,1.89,1.89,0,0,0-.89-.44,5.06,5.06,0,0,0-3.25.28,2.92,2.92,0,0,1-1.31.42c-.46,0-.89-.36-1.37-.44a2,2,0,0,0-1.88,1.1,2.69,2.69,0,0,0-.35,1.3v.08h0a1.9,1.9,0,0,0,.5,1.33c.33.35.82.58,1,1,.06.18,0,.38.09.57l0,.07,0,0a5.76,5.76,0,0,0-1.22,3.55,5.89,5.89,0,0,0,4.14,5.58v.17a2.51,2.51,0,0,1-.8,2l-5.23,2.09s-3.15-.38-4.29,4.23a7.86,7.86,0,0,0-.2,2.34,6.78,6.78,0,0,1-.87,3.5c-1.29,2.53-1,8.35,1.65,8.92a8.62,8.62,0,0,0,3.58.29V77c0,1.09-.44,10.5-1.88,11.64-.4.32-.32.52,0,.67,0,0,0,.06,0,.17a11.73,11.73,0,0,1-1.22,4.8c-1.12,1.73-1,11.69-1,11.69l-.76,5.87s.47,3.63,0,4.26-1,14-1.1,16.89h0a1.42,1.42,0,0,0-1.13.7,19.72,19.72,0,0,1-2.78,2.86c-.47.67-2.21,1.31-3.12,1.61a1.94,1.94,0,0,0-.35.15,1.86,1.86,0,0,0-.79.83.89.89,0,0,0-.08.7c.23.57,5.11,1,6.35.4a42.22,42.22,0,0,1,6.41-1.28,1.32,1.32,0,0,0,1.14-1.14.75.75,0,0,0-.15-.57h0a5.06,5.06,0,0,1-.52-2.09,1.41,1.41,0,0,0,.36-.21,15.33,15.33,0,0,1,.87-6.16c1.18-3.11,1.53-8.87,1.24-12.61,0,0,3.59-15.43,6.41-16.87h0c0,.06,1.41,1.81,1.59,7.25a22,22,0,0,0,2.17,9.15s-.88,9.39,0,12.9l-1.15,5.54-.14-.13s0,.15.08.4l0,.12H154a10.91,10.91,0,0,1,.24,2.62c0,.4-.16,1-.24,1.5-.12.85-.16,1.68.29,1.86.74.3,5.06.7,5.79-.25a1.36,1.36,0,0,0,.21-1.42,1.44,1.44,0,0,0-.21-.36s-1.15-1.88-.82-3.2a1,1,0,0,0-.14-.76,39,39,0,0,1,1-6.2c.74-2.77,2.29-8.85,1.15-12.84h0q-.06-.24-.15-.46a17.25,17.25,0,0,1-.65-6.74,13.73,13.73,0,0,1,0-5.87c.71-3.22,1.2-6.39,1.2-6.39a40.41,40.41,0,0,0,0-6.87,1.71,1.71,0,0,0,0-.17l.19,0s-1-4.43-1.35-7.25c-.08-.67-.19-1.51-.31-2.41a6.14,6.14,0,0,0,1-.24c3.17-1.09,4.17-11,4.17-11V64.89S166.44,60.06,162.74,57.93ZM139.09,134.4l-.16-.08h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M160.82,115.08c1.38,4-.23,10.38-1,13.26a40.08,40.08,0,0,0-1,6.31,13.29,13.29,0,0,1-5-.12l1.21-5.91c-.86-3.5,0-12.85,0-12.85a22.3,22.3,0,0,1-2.12-9.12c-.17-5.42-1.51-7.17-1.55-7.23h0c-2.75,1.43-6.25,16.81-6.25,16.81.29,3.73-.06,9.47-1.21,12.56a15.53,15.53,0,0,0-.86,6.14,1.87,1.87,0,0,1-1.57.3,10.72,10.72,0,0,1-3.6-1.68s.63-16.75,1.09-17.38,0-4.25,0-4.25l.74-5.85s-.12-9.93,1-11.65a11.82,11.82,0,0,0,1.2-4.79v-.17l1.66-2s16.07-1.21,17.27,0a3.44,3.44,0,0,1,.59,1.81,41.11,41.11,0,0,1,0,6.85s-.48,3.16-1.17,6.37a14,14,0,0,0,0,5.85A17.52,17.52,0,0,0,160.82,115.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M159.82,140.24c-.72.95-4.93.55-5.65.25-.44-.17-.4-1-.29-1.86.08-.54.19-1.09.23-1.49a13.73,13.73,0,0,0-.35-3.13s.95,1,1.17,0a1.09,1.09,0,0,1,.82-.78,2.14,2.14,0,0,1,1.49.09c.75.32,2,1,1.77,1.95-.32,1.32.8,3.19.8,3.19a1.45,1.45,0,0,1,.21.36A1.38,1.38,0,0,1,159.82,140.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M159.82,140.24c-.72.95-4.93.55-5.65.25-.44-.17-.4-1-.29-1.86a4.87,4.87,0,0,0,2.51.27,7.07,7.07,0,0,1,.9,0,21,21,0,0,0,2.74-.06A1.38,1.38,0,0,1,159.82,140.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145.1,116.23c.29,3.73-.06,9.47-1.21,12.56a15.53,15.53,0,0,0-.86,6.14,1.87,1.87,0,0,1-1.57.3c.35-2.42,1.82-12.85,2.77-21.09a34.5,34.5,0,0,1,6.11-15.84l1,1.1C148.6,100.85,145.1,116.23,145.1,116.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M158.1,55.92l-.7,3.44L154,65.13l-4.23-1.81s-5.76-6-2.14-6.88a3.2,3.2,0,0,0,1.2-.53,2.48,2.48,0,0,0,.94-2.08,6.37,6.37,0,0,0-.58-2.47l7.4-2.32a11.88,11.88,0,0,0-.52,3,4,4,0,0,0,1.31,3.49A2.22,2.22,0,0,0,158.1,55.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M156.55,49a11.88,11.88,0,0,0-.52,3,5.64,5.64,0,0,1-.43.46,5.86,5.86,0,0,1-5.85,1.33,6.36,6.36,0,0,0-.59-2.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M157.4,48.09a5.85,5.85,0,1,1-5.86-5.85h0A5.83,5.83,0,0,1,157.4,48S157.4,48.07,157.4,48.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M158.1,55.92l-.7,3.44L154,65.13l-4.23-1.81s-5.76-6-2.14-6.88a3.2,3.2,0,0,0,1.2-.53c-.65,1.79,2,5.53,2,5.53.31.46,1,.17,1,.17,1.74-.26,4.93-5.26,5.45-6.09A2.22,2.22,0,0,0,158.1,55.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161.41,89.3c-1,.23-6.66,1.48-8.79,1.17-2.35-.35-6.93-.57-6.93-.57a13.51,13.51,0,0,1-3.81-.25v-.17l1.66-2s16.07-1.21,17.27,0A3.43,3.43,0,0,1,161.41,89.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M150.84,61.6s-3-4.19-1.89-5.83l-5.11,2.09s-3.08-.37-4.19,4.22a8,8,0,0,0-.19,2.33,6.9,6.9,0,0,1-.84,3.49c-1.26,2.52-1,8.32,1.61,8.9a7.85,7.85,0,0,0,3.5.29s-.35,10.5-1.84,11.71,3.8.92,3.8.92,4.57.23,6.93.57,9-1.21,9-1.21-1-4.42-1.32-7.23-1.15-8.8-1.15-8.8L165,65.13s1-4.79-2.58-6.91a40.84,40.84,0,0,0-5-2.64s-3.63,5.91-5.53,6.2C151.87,61.77,151.15,62.06,150.84,61.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M144.12,63.27a8.63,8.63,0,0,0,.29,2.64c.34.74,1.61,4.89,1.61,4.89h-2.87s1.55-1.66,1.44-2.47S144.12,63.27,144.12,63.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M152.62,77.55s-6.34-1.55-6.93-2.87-2.22-4.27-2.22-4.27l.67-.9,3.08,2.42s3.66,2.93,5.39,3.21S152.62,77.55,152.62,77.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M152.62,77.55s-6.34-1.55-6.93-2.87-2.22-4.27-2.22-4.27l.67-.9,3.08,2.42s3.66,2.93,5.39,3.21S152.62,77.55,152.62,77.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M158.1,70.09v3.44h-.55a16.06,16.06,0,0,0-7.8,2l-1,.57-.28.16-1.78-4,1.66-1.49h.09a10,10,0,0,0,2.91-.06,4.74,4.74,0,0,1,3.67-.47c1,.26,1.91,1.42,2.9,1.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M163.63,63.83l1.15,1.29v3.13s-1,9.87-4.07,11-8.63-.63-8.63-.63-1.43-3.79-.76-4S157.22,73,157.22,73s-.07-5.79,1.07-7.51c0,0-.74-5.39,1.84-5.51S163.63,63.83,163.63,63.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M163.81,63.83,165,65.13v3.13s-1,9.87-4.07,11-8.63-.63-8.63-.63-1.43-3.79-.76-4S157.4,73,157.4,73s-.08-5.79,1.07-7.51c0,0-.75-5.39,1.84-5.51S163.81,63.83,163.81,63.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M155.79,50.57a2.31,2.31,0,0,0-.13-1.12.85.85,0,0,0-.91-.52c-.49.12-.7.75-1.18.91a1,1,0,0,1-1-.54,2.68,2.68,0,0,1-.2-1.25V46.61a2.38,2.38,0,0,0-.34-1.5,2.64,2.64,0,0,0-2-.71,1.67,1.67,0,0,0-1.12.45,1.45,1.45,0,0,1-1.18.42,1,1,0,0,1-.82-.71v0a5.85,5.85,0,1,1,8.7,7.77A15.76,15.76,0,0,0,155.79,50.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M147.71,45.11a1,1,0,0,1-.83-.71c0-.18,0-.38-.09-.57-.13-.45-.62-.69-.94-1a2.31,2.31,0,0,1-.15-2.64,1.91,1.91,0,0,1,1.84-1.1c.46.08.87.41,1.34.44a2.7,2.7,0,0,0,1.28-.41,4.82,4.82,0,0,1,3.18-.28,1.83,1.83,0,0,1,.87.44,7.61,7.61,0,0,1,.47.65,3.64,3.64,0,0,0,2.34,1c.85.15,1.82.49,2.09,1.31a3.43,3.43,0,0,1-.1,1.7.51.51,0,0,0,0,.35c.13.22.47.13.72.17.48.1.61.73.63,1.22s0,1.13,0,1.7a2.16,2.16,0,0,1-.05.63,2.22,2.22,0,0,1-.49.79L158,51c-.84,1-1.73,2.18-1.57,3.49a.81.81,0,0,1-1-.58,2.61,2.61,0,0,1,.06-1.29,15.84,15.84,0,0,0,.3-2.24,2.3,2.3,0,0,0-.13-1.12.85.85,0,0,0-.91-.52c-.49.12-.7.75-1.18.91a1,1,0,0,1-1-.54,2.67,2.67,0,0,1-.2-1.25V46.44a2.38,2.38,0,0,0-.34-1.5,2.64,2.64,0,0,0-2-.71,1.67,1.67,0,0,0-1.12.45A1.45,1.45,0,0,1,147.71,45.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M149,63.12l1.8,7.38S152.24,70.5,149,63.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M155.17,61.89s-2.35,3.85-1.43,7.84l.44,0S153.39,67.91,155.17,61.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M156.66,83.69s2.89-1,3.1,1.26C159.76,85,159.22,83.43,156.66,83.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M148.31,71s-.57,4,.46,5.62a12.58,12.58,0,0,1-5,.69L143.37,71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M148.71,76.13l-.28.16-1.78-4,1.66-1.49h.09C148.37,71,147.91,74.42,148.71,76.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M148.31,70.78s-.57,4,.46,5.62a12.55,12.55,0,0,1-5,.69l-2-6.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M143.35,137.8a1.3,1.3,0,0,1-1.11,1.14,40.18,40.18,0,0,0-6.26,1.28c-1.21.57-6,.17-6.2-.4a.91.91,0,0,1,.08-.7,1.84,1.84,0,0,1,.77-.83,2,2,0,0,1,.35-.15c.9-.3,2.59-.93,3-1.6a19.44,19.44,0,0,0,2.71-2.85,1.38,1.38,0,0,1,1.1-.69c.5,0,1.06.23,1.29,1.33,0,0,2.75,1.57,3.49.19a7.55,7.55,0,0,0,.57,2.69h0A.77.77,0,0,1,143.35,137.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M143.35,137.8a1.3,1.3,0,0,1-1.11,1.14,40.18,40.18,0,0,0-6.26,1.28c-1.21.57-6,.17-6.2-.4a.91.91,0,0,1,.08-.7,1.84,1.84,0,0,1,.77-.83c.78.52,2.5,1,6.29.43a27.77,27.77,0,0,0,6.28-1.5h0A.77.77,0,0,1,143.35,137.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159,44v0a5.14,5.14,0,0,0,.17-1.3,8.6,8.6,0,0,1-.17,1A.64.64,0,0,0,159,44Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.66,49.34a1.66,1.66,0,0,1,.14.66,2,2,0,0,0-.14-.91.85.85,0,0,0-.91-.52c-.49.12-.7.75-1.18.91a1,1,0,0,1-1-.54,2.66,2.66,0,0,1-.2-1.25V46.24a2.38,2.38,0,0,0-.34-1.5,2.64,2.64,0,0,0-2-.71,1.67,1.67,0,0,0-1.12.45,1.45,1.45,0,0,1-1.18.42,1,1,0,0,1-.82-.71c0-.19,0-.38-.09-.57-.13-.45-.62-.69-.94-1a1.88,1.88,0,0,1-.48-1.22,2,2,0,0,0,.48,1.47c.32.35.8.58.94,1,.05.17,0,.38.09.57a1,1,0,0,0,.82.71,1.45,1.45,0,0,0,1.18-.42,1.67,1.67,0,0,1,1.12-.45,2.64,2.64,0,0,1,2,.71,2.39,2.39,0,0,1,.34,1.5v1.44a2.64,2.64,0,0,0,.2,1.25,1,1,0,0,0,1,.54c.48-.15.7-.79,1.18-.91A.88.88,0,0,1,155.66,49.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.38,47.76a2.21,2.21,0,0,1-.49.79L158,50.83a5.11,5.11,0,0,0-1.57,3.29,5.64,5.64,0,0,1,1.57-3l1.89-2.28a2.21,2.21,0,0,0,.49-.79,2.18,2.18,0,0,0,.05-.63A1.66,1.66,0,0,1,160.38,47.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.43,53.73a1.34,1.34,0,0,1-.06-.31,1.55,1.55,0,0,0,.06.57.81.81,0,0,0,1,.58,2.46,2.46,0,0,1,0-.25A.81.81,0,0,1,155.43,53.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M136.36,134.21s.6,1,2.77.13"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M154.74,134.47a3.32,3.32,0,0,0,4.24.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.19,108.37s-1.32.83-1.37,1.3.68-.35.68-.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M160.71,114.71a2.77,2.77,0,0,1-1.63.64c-1,0-.91,1.33-.26.95A16.24,16.24,0,0,0,160.71,114.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M161,115.54s-.64,3.12-1.15,2.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M101.89,130.11c0-.35.1-.7.16-1a7.3,7.3,0,0,0-.35-3.54h0c-.06-.18-.11-.29-.11-.29-1.11-.3-5.49,3.1-7.09,4.38-.55,0-1.15,0-1.81.07-.29,0-.57,0-.86,0h-1c-1.48-1.19-6.07-4.78-7.21-4.47,0,0,0,.1-.11.29h0a7.17,7.17,0,0,0-.36,3.54c.06.35.12.7.16,1a5,5,0,0,0,1.57,3.23,21.17,21.17,0,0,0,1.9,5.65,4,4,0,0,0,.24.8,11.83,11.83,0,0,0-.54,3.14s-1.55-.38-1.71,1.49v.06c-.56.26-1.26.84-.47,2.08a.81.81,0,0,0,.4.33c.14,0,.28,0,.26-.15l1,1.09s1.76.2,1.78-.82l.1,0,.73.09.12.4s-1.32,0-1,.78c0,0,.33.31.45.2s-.17.53.51.53c0,0,.74.39,1,.11s.88-.7.94-.87,0-.46,0-1h.11c1.47,0,3,0,4.45-.09h.12c0,.62,0,1.08,0,1.13s.66.59.94.87,1-.11,1-.11c.68,0,.51-.53.51-.53s.45-.2.45-.2c.36-.81-1-.78-1-.78l.16-.52.73-.06h.12c-.07,1.11,1.77.9,1.77.9l1-1.09c0,.2.12.2.26.15a.8.8,0,0,0,.39-.33c1.19-1.86-1-2.25-1-2.25l-.21,0a.36.36,0,0,1,0-.1h0a3.83,3.83,0,0,0,0-.74,1.62,1.62,0,0,0-1.31-1c-.45-.06-.46-2.11-.41-3.53a4.06,4.06,0,0,0,.07-.81,4.27,4.27,0,0,0-.17-1.3,16.62,16.62,0,0,0,1.65-3.49A5.08,5.08,0,0,0,101.89,130.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M100.2,144.25h0c-.07,1-.26,2.52-.26,2.52s-.78.09-2,.2l-.81.07-2.07.14c-1.37.08-2.87.12-4.29.09-.71,0-1.4-.05-2-.12l-.82-.1c-1.63-.24-2.79-.71-2.89-1.52a4.71,4.71,0,0,1,0-1c.15-1.83,1.64-1.46,1.64-1.46a12.63,12.63,0,0,1,.56-3.22c.18-.72.35-1.26.35-1.26l10.49-.7h0a.51.51,0,0,1,.51.51v0c-.06,1.26-.15,4.14.36,4.2a1.58,1.58,0,0,1,1.26.93A3.91,3.91,0,0,1,100.2,144.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M91.29,130.44s-4,4.76-5.86,3.44l-.13-.1a4.85,4.85,0,0,1-1.71-3.33c0-.35-.09-.69-.16-1a7.12,7.12,0,0,1,.35-3.47h0l.11-.28C85.21,125.31,91.29,130.44,91.29,130.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M89.16,130.88s-1.25.87-3,2.31a6.34,6.34,0,0,1-.87.6,4.85,4.85,0,0,1-1.71-3.33c0-.35-.09-.69-.16-1a7.13,7.13,0,0,1,.35-3.47h0C86.24,126.13,89.16,130.88,89.16,130.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M89.16,130.88s-1.25.87-3,2.31a6.34,6.34,0,0,1-.87.6,4.85,4.85,0,0,1-1.71-3.33c0-.35-.09-.69-.16-1a7.13,7.13,0,0,1,.35-3.47h0C86.24,126.13,89.16,130.88,89.16,130.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M87.81,130.41s-.66.47-1.6,1.23a3.38,3.38,0,0,1-.46.32,2.57,2.57,0,0,1-.91-1.77c0-.18,0-.37-.08-.55a3.81,3.81,0,0,1,.19-1.85h0C86.25,127.88,87.81,130.41,87.81,130.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M93.85,130.44s4,4.76,5.86,3.44l.13-.1a4.85,4.85,0,0,0,1.71-3.33c0-.35.09-.69.15-1a7.1,7.1,0,0,0-.35-3.47h0c-.06-.17-.11-.28-.11-.28C99.93,125.31,93.85,130.44,93.85,130.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M96,130.88s1.25.87,3,2.31a6.34,6.34,0,0,0,.86.6,4.85,4.85,0,0,0,1.71-3.33c0-.35.09-.69.15-1a7.1,7.1,0,0,0-.35-3.47h0C98.9,126.13,96,130.88,96,130.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M96,130.88s1.25.87,3,2.31a6.34,6.34,0,0,0,.86.6,4.85,4.85,0,0,0,1.71-3.33c0-.35.09-.69.15-1a7.1,7.1,0,0,0-.35-3.47h0C98.9,126.13,96,130.88,96,130.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97.34,130.41s.66.47,1.59,1.22a3.19,3.19,0,0,0,.46.32,2.58,2.58,0,0,0,.91-1.76c0-.17,0-.36.08-.55a3.82,3.82,0,0,0-.18-1.84h0C98.89,127.89,97.34,130.41,97.34,130.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98,137.85a9.47,9.47,0,0,1-1.51,1.93c-1.57,1.4-8.35.84-8.79.77-.09,0-.28-.29-.52-.73.18-.72.35-1.26.35-1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M92.67,130c-.28,0-.55,0-.83,0-1.42,0-6.18,0-6.71,2-.62,2.27,2.16,8.34,2.6,8.42s7.22.62,8.79-.77a16.91,16.91,0,0,0,3.52-6.15S102,129.4,92.67,130Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.52,133.72a5,5,0,0,0-5.13,2.9,4.19,4.19,0,0,0,.31,4.22,1.93,1.93,0,0,0,2.45.87C92.63,140.69,92.52,133.72,92.52,133.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.41,133.5a5,5,0,0,0-5.13,2.9,4.19,4.19,0,0,0,.31,4.22,1.93,1.93,0,0,0,2.45.87C92.52,140.47,92.41,133.5,92.41,133.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M92.41,133.61a5,5,0,0,0-5.13,2.9,4.19,4.19,0,0,0,.31,4.22,1.93,1.93,0,0,0,2.45.87C92.52,140.58,92.41,133.61,92.41,133.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M92.41,133.61a5,5,0,0,0-5.13,2.9,4.19,4.19,0,0,0,.31,4.22,1.93,1.93,0,0,0,2.45.87C92.52,140.58,92.41,133.61,92.41,133.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M88.65,136.61s-.48.44-.29.55S88.65,136.61,88.65,136.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M89.16,137.18s-.26.57-.07.64.29-.41.29-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M88,138s-.25.68,0,.68S88,138,88,138Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M87.7,139.86a1.93,1.93,0,0,0,1.84,1.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M88.89,140.24a.92.92,0,0,0,1.1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93,133.72a5,5,0,0,1,5.13,2.9,4.19,4.19,0,0,1-.31,4.22,1.93,1.93,0,0,1-2.45.87C92.86,140.69,93,133.72,93,133.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M93.07,133.5a5,5,0,0,1,5.13,2.9,4.19,4.19,0,0,1-.31,4.22,1.93,1.93,0,0,1-2.45.87C93,140.47,93.07,133.5,93.07,133.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M93.07,133.61a5,5,0,0,1,5.13,2.9,4.19,4.19,0,0,1-.31,4.22,1.93,1.93,0,0,1-2.45.87C93,140.58,93.07,133.61,93.07,133.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M93.07,133.61a5,5,0,0,1,5.13,2.9,4.19,4.19,0,0,1-.31,4.22,1.93,1.93,0,0,1-2.45.87C93,140.58,93.07,133.61,93.07,133.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M96.84,136.61s.48.44.29.55S96.84,136.61,96.84,136.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M96.32,137.18s.26.57.08.64-.29-.41-.29-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M97.48,138s.25.68,0,.68S97.48,138,97.48,138Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M97.79,139.86A1.93,1.93,0,0,1,96,141.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M96.6,140.24a.92.92,0,0,1-1.1.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M91.09,143.55a5.07,5.07,0,0,1,3.63,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M87.94,147.06c-1.63-.24-2.79-.71-2.89-1.52a4.71,4.71,0,0,1,0-1,2.35,2.35,0,0,1,.62-.23,2.79,2.79,0,0,1,1.43.19c.77.22.71,1.13.87,2.31A1,1,0,0,1,87.94,147.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M85.52,144.38s-2.11.39-1,2.21a.78.78,0,0,0,.39.32c.13,0,.26,0,.25-.14l.94,1.07s1.87.22,1.7-1-.11-2.09-.87-2.31A2.89,2.89,0,0,0,85.52,144.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M86,145.61s.45,1,1.07.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M85,146s.23,1,1.11.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.2,144.25h0c-.07,1-.26,2.52-.26,2.52s-.78.09-2,.2a1,1,0,0,1,0-.2c.16-1.18.11-2.09.87-2.31A3.36,3.36,0,0,1,100.2,144.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M100.39,144.38s2.12.39,1,2.21a.79.79,0,0,1-.39.32c-.13,0-.27,0-.25-.14l-.93,1.07s-1.87.22-1.7-1,.11-2.09.87-2.31A2.88,2.88,0,0,1,100.39,144.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M99.89,145.61s-.45,1-1.07.16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M100.92,146s-.23,1-1.11.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90.79,147.27c-.71,0-1.4-.05-2-.12L88.12,145a1.39,1.39,0,0,1-.06-.39,1.36,1.36,0,0,1,2.71,0C90.79,145.45,90.79,146.51,90.79,147.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M88,145l.75,2.52s-1.27,0-.92.77c0,0,.32.3.43.19s-.17.52.49.52c0,0,.71.39,1,.11s.85-.69.91-.85,0-2.21,0-3.66a1.35,1.35,0,0,0-1.36-1.34h0A1.36,1.36,0,0,0,88,145Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M89,148.19s-.55.52-.26.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M88.78,147.86a.75.75,0,0,0-.51.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97.81,144.63a1.38,1.38,0,0,1-.06.39l-.59,2-2.07.14c0-.75,0-1.76,0-2.56a1.36,1.36,0,0,1,2.71,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M97.86,145l-.75,2.52s1.27,0,.92.77c0,0-.32.3-.43.19s.16.52-.5.52c0,0-.71.39-1,.11s-.85-.69-.91-.85,0-2.21,0-3.66a1.35,1.35,0,0,1,1.36-1.34h0a1.36,1.36,0,0,1,1.3,1.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M96.85,148.19s.55.52.26.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M97.09,147.86a.75.75,0,0,1,.51.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.42,133.06S89.83,133,89.75,135s4,1.15,4,1.15,1.73-.23,1.43-1.45S94.29,133.17,92.42,133.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.42,132.84s-2.58-.08-2.67,1.92,4,1.15,4,1.15,1.73-.23,1.43-1.45S94.29,133,92.42,132.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M92.42,133s-2.58-.08-2.67,1.92,4,1.15,4,1.15,1.73-.23,1.43-1.45S94.29,133.06,92.42,133Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M86.65,143s.87.31,1,.91"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M99,142.59s-.62.26-.58,1.35"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 87.02,
    cy: 147.57,
    rx: 0.4,
    ry: 0.67,
    transform: "translate(-61.96 62.99) rotate(-29.89)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 99.3,
    cy: 146.97,
    rx: 0.67,
    ry: 0.4,
    transform: "translate(-77.63 159.49) rotate(-60)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 87.02,
    cy: 147.57,
    rx: 0.4,
    ry: 0.67,
    transform: "translate(-61.96 62.99) rotate(-29.89)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 99.3,
    cy: 146.97,
    rx: 0.67,
    ry: 0.4,
    transform: "translate(-77.63 159.49) rotate(-60)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 33.61,
    cy: 124.94,
    rx: 4.7,
    ry: 0.79
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 15.1,
    cy: 136.2,
    rx: 4.7,
    ry: 0.79
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 10.2,
    cy: 126.12,
    rx: 7.02,
    ry: 1.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M7.3,124.18a2,2,0,0,1-.67-1,.9.9,0,0,1,.47-1,1.31,1.31,0,0,1,1.24.43,1.66,1.66,0,0,0,1.2.58A1.83,1.83,0,0,1,9,121.45a.7.7,0,0,1,.16-.35c.24-.25.67-.14,1,.06a3.56,3.56,0,0,1,1.16,3,5.5,5.5,0,0,0,0-1.22,1.26,1.26,0,0,1,.46-1.09,1.4,1.4,0,0,1,.7-.17,1.46,1.46,0,0,1,1.14.32,1.12,1.12,0,0,1,0,1.4,4.56,4.56,0,0,1-1.18.95,2.6,2.6,0,0,0-.84.8.82.82,0,0,0-.06.14H8.88A7.06,7.06,0,0,1,7.3,124.18Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 179.69,
    cy: 131.58,
    rx: 4.7,
    ry: 0.79
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M176.53,127.89s2.68-.08,3.49-.66,4.12-1.26,4.32-.34,4,4.59,1,4.61-7-.47-7.84-1S176.53,127.89,176.53,127.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M185.4,131.18c-3,0-7-.47-7.84-1-.61-.37-.86-1.72-.94-2.33h-.09s.17,2.16,1,2.65,4.81,1,7.84,1c.87,0,1.18-.32,1.16-.78C186.38,131,186,131.18,185.4,131.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M35.54,51a1.09,1.09,0,0,1-.19.56A9.51,9.51,0,0,0,38,50.67a9.16,9.16,0,0,0,.12,2.74,11.45,11.45,0,0,0,.55,2.19,54.17,54.17,0,0,0,2.63,7.45,15,15,0,0,1,.93,3c.65,3.93-1.61,7.72-2,11.68a2.22,2.22,0,0,0,0,.66l-.1.13C38.48,81,38.68,85,39,87.89A42.71,42.71,0,0,0,41,96.29a16.46,16.46,0,0,1,.6,2.33,15.47,15.47,0,0,1,.07,3.26c-.28,5.06-1,10.16-.16,15.14.61,3.63,1.95,6.93,2.1,10.61a1.79,1.79,0,0,1,.51-.7l.25,9.66a.56.56,0,0,0,.18.49c.18.11.41,0,.62,0,.61-.07,1,.59,1.42,1.06a3.64,3.64,0,0,0,2.48,1.1,10.91,10.91,0,0,0,2.77-.25,2.27,2.27,0,0,0,1.2-.47,1.48,1.48,0,0,0,.41-1.28c-.18-1.42-1.71-2.23-2.49-3.45-.91-1.43-.7-3.36-1.59-4.81-.31-.5-.73-.92-1-1.43a5.71,5.71,0,0,1-.32-1,2.86,2.86,0,0,1,.78.37l-.25-2.27,0-.33c-.11-1-.23-2-.32-3.07-.29-3.37.67-6.68,0-10a4.46,4.46,0,0,1,.29-2.12,52.71,52.71,0,0,0,2.14-12,15.6,15.6,0,0,1,.54-4.19c.54,2.2,2.21,3.94,3.26,6,.65,1.26,1.05,2.63,1.76,3.86a10.62,10.62,0,0,1,1,1.81,6.88,6.88,0,0,1,0,3.17,91.72,91.72,0,0,0-.43,16.57,26.25,26.25,0,0,1-1.45,6.18,2.81,2.81,0,0,0-.16,2.42,2.49,2.49,0,0,0,.7.65A16.45,16.45,0,0,0,58,134.8a1.08,1.08,0,0,0,.73.17,1.67,1.67,0,0,0,.44-.23,2.3,2.3,0,0,1,1.92-.07c.62.22,1.19.58,1.79.85a6.12,6.12,0,0,0,4,.28,1.8,1.8,0,0,0,1.34-1,1.46,1.46,0,0,0-.59-1.5,8.4,8.4,0,0,0-1.5-.82,6.18,6.18,0,0,1-2.62-2.61,12.13,12.13,0,0,1-.82-2.3l-.81-2.85a4,4,0,0,1,.44.33,105.09,105.09,0,0,1,1.77-14,21,21,0,0,0,.87-6.68,18.72,18.72,0,0,0-.85-3.45q-1.63-5.31-2.86-10.73a3.61,3.61,0,0,0,.7-1.16,8.58,8.58,0,0,0,.43-2.47,118.78,118.78,0,0,0,0-17,13.29,13.29,0,0,0-.84-4.25h.33c-.39,0-1-3.91-1.11-4.34-.26-1.51-.45-3-.72-4.54-.13-.73-.28-1.47-.47-2.19-.13-.48-.63-3.46-1-3.79a.5.5,0,0,0-.14-.08,2.85,2.85,0,0,0-1.24-1.61,3.77,3.77,0,0,0-2.17-.32l-.64-.92a5.38,5.38,0,0,1-.88-1.67A4.09,4.09,0,0,1,53.3,45c0-.17,0-.35,0-.52v-.26a4.32,4.32,0,0,0-.06-.52h0c0-.14-.06-.28-.1-.42l-.06-.18c-.11-.35-.23-.7-.33-1.05a12.54,12.54,0,0,1-.1-3.52,5.63,5.63,0,0,0-.7-3.41c-.49-.72-1.27-1.27-1.53-2.1a8.28,8.28,0,0,0-.3-1.2,2,2,0,0,0-1.06-.89,3.18,3.18,0,0,0-2.15-.27.84.84,0,0,0-.27.22,3.41,3.41,0,0,1-1.73-.15c-.41-.2-.7-.59-1.09-.81-.93-.52-2.12,0-2.95.68a8.5,8.5,0,0,0-2.77,4.17c-.37,1.26-.52,2.73-1.57,3.53-.44.33-1,.51-1.32,1a2.42,2.42,0,0,0-.35,1.19,7.59,7.59,0,0,0,.05,2.87c.19.7.57,1.32.8,2a5.28,5.28,0,0,1-1.46,5.51A1.74,1.74,0,0,0,35.54,51Zm22.4,28.26a2.51,2.51,0,0,0,1.26-1.67l.07.27a6.47,6.47,0,0,1-.17,3.68A13.22,13.22,0,0,0,57.94,79.31Zm.47-5.16a9.59,9.59,0,0,1-1-1.78,7.59,7.59,0,0,1-.19-3.17,15,15,0,0,1,.34-2.41,51.44,51.44,0,0,0,.84,7.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M49.39,31.55a2,2,0,0,1,1,.88,8.49,8.49,0,0,1,.29,1.19c.26.82,1,1.37,1.5,2.1a5.69,5.69,0,0,1,.68,3.39,12.51,12.51,0,0,0,.1,3.49c.14.55.38,1.08.47,1.64s0,1.4.19,2.07A5.34,5.34,0,0,0,54.53,48L56,50.2a17.19,17.19,0,0,1-2-.61,3.57,3.57,0,0,0,1.08,1.63L54,49.9a3.1,3.1,0,0,0-.82-.77,4.24,4.24,0,0,0-1.33-.36,3.12,3.12,0,0,1-2.17-1.4c-.57-1-.2-2.35-.52-3.49A12.89,12.89,0,0,0,48,41.58c-.89-1.74-.84-3.79-1.12-5.74a17.9,17.9,0,0,1-.31-2.47c0-.61.06-1.78.7-2.1A3.24,3.24,0,0,1,49.39,31.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M61.6,123.49l1.16,4.14a12.06,12.06,0,0,0,.81,2.29,6.08,6.08,0,0,0,2.56,2.6,8.6,8.6,0,0,1,1.48.82,1.47,1.47,0,0,1,.58,1.49,1.79,1.79,0,0,1-1.32,1,6,6,0,0,1-4-.29c-.59-.26-1.15-.63-1.76-.84a2.24,2.24,0,0,0-1.89.07,1.66,1.66,0,0,1-.44.23,1,1,0,0,1-.72-.17,16,16,0,0,1-2-1.25,2.42,2.42,0,0,1-.68-.65,2.82,2.82,0,0,1,.15-2.4,26.35,26.35,0,0,0,1.45-6.4.67.67,0,0,1,.21-.52.66.66,0,0,1,.34-.07l5-.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M48.72,127.63c.27.51.68.93,1,1.42.87,1.44.67,3.35,1.56,4.78.76,1.21,2.26,2,2.44,3.43a1.49,1.49,0,0,1-.4,1.27,2.26,2.26,0,0,1-1.18.45,10.53,10.53,0,0,1-2.72.25,3.58,3.58,0,0,1-2.44-1.1c-.4-.47-.79-1.13-1.4-1-.21,0-.44.14-.61,0a.56.56,0,0,1-.18-.48L44.51,126a9,9,0,0,1,3.26-.14C48.51,126.16,48.39,127,48.72,127.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M57.42,78.67c2.15,2.67,2.78,6.21,3.47,9.57q1.33,6.5,3.28,12.85a19.24,19.24,0,0,1,.83,3.43,21.27,21.27,0,0,1-.85,6.64,105.81,105.81,0,0,0-1.74,14,4.46,4.46,0,0,0-5.41-.29,94.27,94.27,0,0,1,.4-16.93,7.22,7.22,0,0,0,0-3.15,10.27,10.27,0,0,0-1-1.8c-.7-1.22-1.09-2.59-1.73-3.84-1-2-2.66-3.73-3.2-5.92A15.63,15.63,0,0,0,51,97.36a53,53,0,0,1-2.1,12,4.44,4.44,0,0,0-.29,2.1c.65,3.3-.29,6.59,0,9.94.08,1,.2,2,.31,3l0,.33.25,2.25a4.55,4.55,0,0,0-3-.49,3.27,3.27,0,0,0-1.11.2,1.81,1.81,0,0,0-1,1c-.14-3.66-1.45-6.94-2.05-10.55-.83-5-.13-10,.15-15.07a15.61,15.61,0,0,0-.07-3.25,16.73,16.73,0,0,0-.59-2.33,43,43,0,0,1-2-8.36c-.28-2.86-.48-6.9,1.07-9.32.48-.75,1.66-.41,2.41-.89a6.07,6.07,0,0,1,1.91-.78C48.93,76.23,53.25,78.31,57.42,78.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M50.06,45.51c.09,1,.31,2.22,1.23,2.65A6.88,6.88,0,0,0,53,48.4a3.56,3.56,0,0,1,2.46,2,8.92,8.92,0,0,1,.79,3.15,6.06,6.06,0,0,1-.55,4A4.51,4.51,0,0,1,53,59.27a7.56,7.56,0,0,1-6.32-1.16,14.16,14.16,0,0,1-2.33-2.3C42.79,54,41.23,52,40.91,49.69a.77.77,0,0,1,.18-.75.81.81,0,0,1,.5-.1l1.48,0a1.37,1.37,0,0,0,1.06-.28,1.34,1.34,0,0,0,.23-1l-.1-4.31a.62.62,0,0,1,.1-.44.57.57,0,0,1,.34-.15,24.11,24.11,0,0,0,2.47-.22c.76-.21,2-1.08,2.52-.19S50,44.64,50.06,45.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M50.06,45.51c.09,1,.31,2.22,1.23,2.65A6.88,6.88,0,0,0,53,48.4a3.56,3.56,0,0,1,2.46,2,8.92,8.92,0,0,1,.79,3.15,6.06,6.06,0,0,1-.55,4A4.51,4.51,0,0,1,53,59.27a7.56,7.56,0,0,1-6.32-1.16,14.16,14.16,0,0,1-2.33-2.3C42.79,54,41.23,52,40.91,49.69a.77.77,0,0,1,.18-.75.81.81,0,0,1,.5-.1l1.48,0a1.37,1.37,0,0,0,1.06-.28,1.34,1.34,0,0,0,.23-1l-.1-4.31a.62.62,0,0,1,.1-.44.57.57,0,0,1,.34-.15,24.11,24.11,0,0,0,2.47-.22c.76-.21,2-1.08,2.52-.19S50,44.64,50.06,45.51Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-31",
    cx: 46.33,
    cy: 39.56,
    r: 5.67
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M52.42,55.33a2.57,2.57,0,0,0,2.39-1,3.19,3.19,0,0,0,.2-1.84l-.33-3.49a4.37,4.37,0,0,1,2.62.27,3.8,3.8,0,0,1,1.52,3.06c.22,2.21-.14,4.45,0,6.67.1,1.86.53,3.79,0,5.57-.23.75-.62,1.43-.87,2.17a11.7,11.7,0,0,0-.47,2.92,7.6,7.6,0,0,0,.19,3.15,18.48,18.48,0,0,0,1.29,2.33c.68,1.3.82,3.05-.2,4.11a4,4,0,0,1-3.77.7,21.56,21.56,0,0,0-3.89-.94c-2.36-.1-4.46,1.43-6.76,1.93a2.1,2.1,0,0,1-.94,0,2.33,2.33,0,0,1-.76-.41l-1.26-.91a1.74,1.74,0,0,1-.61-.62,1.67,1.67,0,0,1-.08-.89c.42-3.93,2.65-7.71,2-11.61a15,15,0,0,0-.91-3c-1.6-4.1-3.52-8.35-2.9-12.7a4.82,4.82,0,0,1,1.08-2.66,2.3,2.3,0,0,1,2.65-.61c.86.46,1.16,1.47,1.54,2.36a10.86,10.86,0,0,0,3.37,4.35,4.17,4.17,0,0,0,2.2,1.11C50.56,55.37,51.49,55.31,52.42,55.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M60.63,64.13c1.37,1.53,1.64,3.73,1.8,5.77a118.71,118.71,0,0,1,0,16.91,8.66,8.66,0,0,1-.42,2.46,3.06,3.06,0,0,1-1.62,1.81c-.5.2-1.19.15-1.41-.34s.1-.93.33-1.37a5,5,0,0,0,.5-3.25,1.52,1.52,0,0,0-.47.92l-.45,1.89c-.61-.09-.84-.83-.93-1.44a6,6,0,0,1,.09-3.29c.23-.55.63-1,.86-1.55a6.78,6.78,0,0,0,.44-4.38,51.32,51.32,0,0,1-1.67-15A6.37,6.37,0,0,0,60.63,64.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M61.93,65.67a20.92,20.92,0,0,0-5,.66,10.85,10.85,0,0,1,0-3.26l.72-7.45c.05-.55,0-5.62,1-4.73.39.33.89,3.29,1,3.77.19.72.33,1.44.47,2.18.27,1.5.45,3,.7,4.51C60.91,61.79,61.54,65.67,61.93,65.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M48.49,32.36a1,1,0,0,0-.12-.51.85.85,0,0,0-.61-.32c-.82-.13-1.72.2-2.46-.17-.4-.2-.68-.58-1.07-.8a2.7,2.7,0,0,0-2.9.68,8.45,8.45,0,0,0-2.72,4.14c-.36,1.25-.51,2.72-1.55,3.51-.43.33-1,.51-1.3.95A2.41,2.41,0,0,0,35.43,41a7.66,7.66,0,0,0,.05,2.85c.19.7.56,1.31.79,2a5.29,5.29,0,0,1-1.44,5.5,1.7,1.7,0,0,0,1.27.22,1.12,1.12,0,0,1-.18.56c1.33,0,2.48-1.33,3.78-1.05,1,.21,1.54,1.24,2.28,1.93a3.43,3.43,0,0,0,3.63.74A2.63,2.63,0,0,0,47,50.48c-.58-1.37-2.36-1.91-3-3.26-.48-1-.12-2.28-.23-3.42A16.22,16.22,0,0,0,43,40.93a3.56,3.56,0,0,1,.19-2.87,4.7,4.7,0,0,1,2.67-1.55C48.14,35.77,48.57,34.63,48.49,32.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M47.1,52.73a4.35,4.35,0,0,0,0-2.39c-.53-1.4-2.26-1.85-3.46-2.75a4.7,4.7,0,0,1-1.54-2.05c-.22-.57-.25-1.36.29-1.65a1.31,1.31,0,0,1,.67-.12,8.41,8.41,0,0,1,5,2.26,6.76,6.76,0,0,1,2,2.51,8.21,8.21,0,0,1,.47,2.25l.3,2.54a40,40,0,0,1,.35,4.39,19.68,19.68,0,0,1-.16,2.51,3.63,3.63,0,0,1-.53,1.69,3.68,3.68,0,0,1-3,1.14A5.26,5.26,0,0,1,46.31,63c-1.85-.4-3.25-3-1.85-4.59.59-.68,1.48-.7,1.82-1.63A31.39,31.39,0,0,0,47.1,52.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M45.59,53.18l1.47,2.38a1.09,1.09,0,0,1,.18.41,1.28,1.28,0,0,1-.38.84c-1.26,1.71-.93,4.08-.56,6.17a11.18,11.18,0,0,1-7.7-9.07c-.18-1.25-.48-3.3.63-4.11C41.89,47.84,44.34,51.13,45.59,53.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M53,48.4a6.38,6.38,0,0,1-1.71-.24c-.93-.43-1.14-1.63-1.23-2.65,0-.1,0-.2,0-.31a8.39,8.39,0,0,1,1.08-.93,5.3,5.3,0,0,1,1.1-.49l1-.36a5.82,5.82,0,0,1,.23.84c.12.68,0,1.4.19,2.07A5.34,5.34,0,0,0,54.55,48l1.52,2.22L55.24,50A3.45,3.45,0,0,0,53,48.4Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGfxNoTeams);
export default __webpack_public_path__ + "static/media/gfx-no-teams.3b4ba695493f81670011cf29d7fa92ad.svg";
export { ForwardRef as ReactComponent };